import { typeDataToArray } from "./_typeDataToArray.js";
export const toSet = async (source) => {
    const dataFunc = source.dataFunc;
    const values = await typeDataToArray(dataFunc);
    return new Set(values);
};
